if (!customElements.get('designers-grid')) {
  customElements.define(
    'designers-grid',

    class DesignersGrid extends HTMLElement {
      constructor() {
        super();
        this.shopifyEndpoint = 'https://wowconcept.myshopify.com/api/2024-10/graphql.json';
        this.storefrontAccessToken = 'c008e7b334ef22d19eca1edad4448208';
      }

      connectedCallback() {
        this.renderCollectionsList();
      }

      async fetchCollectionsWithBrandTemplate() {
        const collections = [];
        let hasNextPage = true;
        let cursor = null;

        while (hasNextPage) {
          const response = await fetch(this.shopifyEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
            },
            body: JSON.stringify({
              query: `
                {
                  collections(first: 250 ${cursor ? `, after: "${cursor}"` : ''}) {
                    edges {
                      cursor
                      node {
                        id
                        title
                        handle
                        metafield(namespace: "collection", key: "is_brand") {
                          value
                        }
                      }
                    }
                    pageInfo {
                      hasNextPage
                    }
                  }
                }
              `,
            }),
          });

          const data = await response.json();
          const newCollections = data?.data?.collections?.edges || [];

          newCollections.forEach((edge) => {
            if (edge.node.metafield && edge.node.metafield.value === 'true') {
              collections.push(edge.node);
            }
          });

          hasNextPage = data.data.collections.pageInfo.hasNextPage;
          cursor = hasNextPage ? data.data.collections.edges.slice(-1)[0].cursor : null;
        }

        collections.sort((a, b) => a.title.localeCompare(b.title));

        const groupedCollections = collections.reduce((acc, collection) => {
          const firstChar = collection.title.charAt(0).toUpperCase();
          const letter = /^[A-Z]$/.test(firstChar) ? firstChar : '#';
          if (!acc[letter]) acc[letter] = [];
          acc[letter].push(collection);
          return acc;
        }, {});

        return groupedCollections;
      }

      async renderCollectionsList() {
        const groupedCollections = await this.fetchCollectionsWithBrandTemplate();

        Object.keys(groupedCollections).forEach((letter) => {
          const lowerCaseLetter = letter.toLowerCase();
          const selector = lowerCaseLetter === '#' ? `.designers__list--\\#` : `.designers__list--${lowerCaseLetter}`;
          const letterContainer = document.querySelector(selector);

          if (letterContainer) {
            groupedCollections[letter].forEach((collection) => {
              const listItem = document.createElement('div');
              listItem.classList.add('designer-item');
              listItem.innerHTML = `
                <a href="/collections/${collection.handle}" class="designer-link">
                  ${collection.title}
                </a>
              `;
              letterContainer.appendChild(listItem);
            });
          }
        });
      }
    }
  );
}
